import * as React from "react";
import { BarChart } from "@mui/x-charts";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { getBackend } from "../../api/backend";
import { useEffect, useState } from "react";
import { CircularProgress } from "@mui/material";
import { Box } from "@mui/material";

export default function ThirdChart() {
  const [chartData, setChartData] = useState({
    labels: [],
    data: {},
    status_colors: {},
  });
  const [selectedTaskClass, setSelectedTaskClass] = useState(null);
  const [taskClasses, setTaskClasses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchTaskClasses = async () => {
      try {
        const response = await getBackend("task_classes/");
        setTaskClasses(response);
      } catch (error) {
        console.error("Error fetching task classes:", error);
      }
    };

    const fetchData = async () => {
      try {
        const params = selectedTaskClass
          ? { task_classes: [selectedTaskClass.uuid] }
          : {};
        const data = await getBackend("task-user-chart-data", { params });

        setChartData({
          labels: data.labels,
          data: data.data,
          status_colors: data.status_colors,
        });
      } catch (error) {
        console.error("Error fetching the chart data", error);
      }
    };

    fetchTaskClasses();
    fetchData().then(() => setIsLoading(false));
  }, [selectedTaskClass]);

  const states =
    Object.keys(chartData.data).length > 0
      ? Object.keys(chartData.data[Object.keys(chartData.data)[0]])
      : [];

  const filteredSeries = states.map((status) => ({
    label: status,
    data: chartData.labels.map((user) => chartData.data[user]?.[status] || 0),
    stack: "statuses",
    color: chartData.status_colors[status],
  }));

  return isLoading ? <CircularProgress/> : (
    <Box sx={{ width: "95%", maxWidth: 800 }}>
    <Stack direction="column" spacing={1} sx={{ alignItems: "center"}}>
      <Stack
        direction="column"
        spacing={4}
        sx={{ width: "100%", maxWidth: 800 }}
      >
        <Autocomplete
          disablePortal
          id="task-classes-standard"
          options={taskClasses}
          getOptionLabel={(option) => option.task_class}
          value={selectedTaskClass || null}
          onChange={(event, newValue) => setSelectedTaskClass(newValue)}
          isOptionEqualToValue={(option, value) => option.uuid === value?.uuid}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
              label="Filtrar por tipo de tarea"
              placeholder="Seleccionar"
            />
          )}
        />
      </Stack>

      <BarChart
        sx={{ width: "100%", maxWidth: 800 }}
        height={350}
        series={filteredSeries}
        xAxis={[
          {
            data: chartData.labels,
            scaleType: "band",
            label: "Usuarios",
          },
        ]}
        borderRadius={8}
      />
    </Stack>
    </Box>
  );
}
